<div class="content content-fixed">
  <div class="container">
    <div class="mb-3 page-title-box d-sm-flex align-items-center justify-content-between">
      <h4 class="mb-0">{{'User Management' | translate}}</h4>
      <div class="d-none d-md-block">
        <button class="btn btn-sm btn-default btn-uppercase align-items-center me-2" data-toggle="modal"
          data-target="#addUser" (click)="addUser()" *ngIf="hasAccess('Users')">
          <i data-feather="plus-circle" class="mr-1"></i>{{'Add User' | translate}}
        </button>
        <button class="btn btn-sm btn-default btn-uppercase align-items-center" data-toggle="modal"
          data-target="#addRole" (click)="addRole()" *ngIf="hasAccess('Roles') && currentOrganizationId == 1">
          <i data-feather="plus-circle" class="mr-1"></i>{{'Add Role' | translate}}
        </button>
      </div>
    </div>
    <div class="alert-success messagebox success-msg-box" role="alert" *ngIf="successmsg">{{messagecont}}</div>
    <section id="tabs" class="project-tab accsmng-tab">
      <div class="container">
        <div class="col-sm-12 pad0">
          <div class="col-md-12 table-bg pad0">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link" [ngClass]="{'active': hasAccess('Users')}" id="nav-user-tab"
                  data-toggle="tab" href="#nav-user" role="tab" aria-controls="nav-user" aria-selected="true"
                  *ngIf="hasAccess('Users')">{{'USERS' | translate}}</a>
                <a class="nav-item nav-link" [ngClass]="{'active': !hasAccess('Users') && hasAccess('Roles')}"
                  id="nav-role-tab" data-toggle="tab" href="#nav-role" role="tab" aria-controls="nav-role"
                  aria-selected="false" *ngIf="hasAccess('Roles') && currentOrganizationId == 1">{{'ROLES' | translate}}</a>
                <a class="nav-item nav-link"
                  [ngClass]="{'active': !hasAccess('Users') && !hasAccess('Roles') && hasAccess('Permissions')}"
                  id="nav-permissions-tab" data-toggle="tab" href="#nav-permissions" role="tab"
                  aria-controls="nav-permissions" aria-selected="false" *ngIf="hasAccess('Permissions') && currentOrganizationId == 1">{{'PERMISSIONS' | translate}}</a>
                <a class="nav-item nav-link" id="nav-vendor-roles-tab"
                  data-toggle="tab" href="#nav-vendor-roles" role="tab"
                  aria-controls="nav-vendor-roles" aria-selected="false"
                  *ngIf="hasAccess('Permissions') && currentOrganizationId == 1">{{'VENDOR ROLES' | translate}}</a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade" [ngClass]="{'show active': hasAccess('Users')}" id="nav-user" role="tabpanel"
                aria-labelledby="nav-user-tab">
                <table *ngIf="!isLoading" class="table table-striped table-bordered" cellspacing="0">
                  <thead>
                    <tr>
                      <th>{{'Organization' | translate}}</th>
                      <th>{{'First Name' | translate}}</th>
                      <th>{{'Last Name' | translate}}</th>
                      <th>{{'Username' | translate}}</th>
                      <th>{{'Email Address' | translate}}</th>
                      <th>{{'Phone Number' | translate}}</th>
                      <th>{{'Roles Assigned' | translate}}</th>
                      <th>{{'Status' | translate}}</th>
                      <th>{{'Actions' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let user of usersList | paginate: { id: 'users', itemsPerPage: 10, currentPage: p }">
                      <td>{{user.org_name}}</td>
                      <td>{{user.first_name}}</td>
                      <td>{{user.last_name}}</td>
                      <td>{{user.username}}</td>
                      <td>{{user.email}}</td>
                      <td>{{user.phone}}</td>
                      <td>{{user.role_name}}</td>
                      <td>{{user.status ? 'Active' : 'Inactive'}}</td>
                      <td>
                        <div class="d-flex justify-content-between align-items-center">
                          <button
                            class="btn btn-xs btn-default d-flex align-items-center"
                            (click)="deleteUser(user)">
                            <app-svg-icons [iconName]="'trash'" class="me-1"></app-svg-icons>
                            {{ 'Delete' | translate }}
                          </button>
                          <button
                            class="btn btn-xs btn-default d-flex align-items-center"
                            data-toggle="modal"
                            data-target="#addUser"
                            (click)="userEdit(user)">
                            <app-svg-icons [iconName]="'edit'" class="me-1"></app-svg-icons>
                            {{ 'Edit' | translate }}
                          </button>
                        </div>

                      </td>
                    </tr>
                  </tbody>
                </table>
                <span *ngIf="!isLoading" class="float-right pt-2">
                  <pagination-controls id="users" (pageChange)="p = $event"></pagination-controls>
                </span>
                <app-spinner *ngIf="isLoading" class="spinner-position"></app-spinner>
              </div>
              <div class="tab-pane fade" [ngClass]="{'show active': !hasAccess('Users') && hasAccess('Roles')}"
                id="nav-role" role="tabpanel" aria-labelledby="nav-role-tab">
                <table *ngIf="!isLoading" class="table table-striped table-bordered" cellspacing="0">
                  <thead>
                    <tr>
                      <th>{{'Role' | translate}}</th>
                      <th>{{'Description' | translate}}</th>
                      <!-- <th>STATUS</th> -->
                      <th>{{'Actions' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let role of rolesList | paginate: { id: 'roles', itemsPerPage: 10, currentPage: q }">
                      <td>{{role.role}}</td>
                      <td>{{role.description}}</td>
                      <!-- <td>{{role.status ? 'Active' : 'Inactive'}}</td> -->
                      <td>
                        <button class="flex items-center justify-center m-1 btn btn-xs btn-default" data-toggle="modal" data-target="#addRole"
                          (click)="roleEdit(role)">
                          <app-svg-icons [iconName]="'edit'"></app-svg-icons>{{'Edit' | translate}}
                        </button>
                        <button class="btn btn-xs btn-default" (click)="deleteRole(role)">
                          <app-svg-icons [iconName]="'trash'"></app-svg-icons>{{'Delete' | translate}}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <span *ngIf="!isLoading" class="float-right pt-2">
                  <pagination-controls id="roles" (pageChange)="q = $event"></pagination-controls>
                </span>
                <app-spinner *ngIf="isLoading" class="spinner-position"></app-spinner>
              </div>
              <div class="tab-pane fade"
                [ngClass]="{'show active': !hasAccess('Users') && !hasAccess('Roles') && hasAccess('Permissions')}"
                id="nav-permissions" role="tabpanel" aria-labelledby="nav-permissions-tab">
                <table *ngIf="!isLoading" mat-table class="standard-table standard-table-bordered">
                  <thead>
                    <tr>
                      <th width="20%">{{'Screen / Feature Name' | translate}}</th>
                      <th *ngFor="let roles of rolesList">{{roles.role | titlecase}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let pages of pageList">
                      <td>
                        <span class="font-weight-bold" style="font-size: 14px;" *ngIf="pages.parent">{{pages.name | titlecase}}</span>
                        <span class="ml-3" style="font-size: 14px;" *ngIf="!pages.parent">{{getPermissionName(pages.name) | titlecase}}</span>
                      </td>
                      <td *ngFor="let roles of rolesList">
                        <label class="mb-0 switch" *ngIf="!roles.permissions[pages.name]?.hasChild && roles.permissions[pages.name]">
                          <input type="checkbox" name="{{roles.permissions[pages.name].name}}"
                            [(ngModel)]="roles.permissions[pages.name].enable">
                          <div class="slider round btn-primary"> <span class="on">{{'Yes' | translate}}</span> <span class="off">{{'No' | translate}}</span>
                          </div>
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <app-spinner *ngIf="isLoading" class="spinner-position"></app-spinner>
                <div *ngIf="!isLoading" class="text-right table-footer save-permission">
                  <button type="button" class="btn btn-primary" (click)="savePermission(rolesList)">{{'Save Permissions' | translate}}</button>
                </div>
              </div>
              <div class="tab-pane fade" id="nav-vendor-roles" role="tabpanel"
                aria-labelledby="nav-vendor-roles-tab">
                <app-vendor-roles></app-vendor-roles>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
<div class="modal fade" id="addUser" tabindex="-1" role="dialog" aria-labelledby="newUserModal" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <app-spinner *ngIf="isModalLoading" class="spinner-position"></app-spinner>
    <div class="modal-content" *ngIf="!isModalLoading">
      <div class="modal-header">
        <h6 class="modal-title" id="newUserModal" *ngIf="isUserCreate">{{'Add User' | translate}}</h6>
        <h6 class="modal-title" id="newUserModal" *ngIf="!isUserCreate">{{'Edit User' | translate}}</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="userForm.reset()" #closeUser> <span
            aria-hidden="true">×</span>
        </button>
      </div>
      <form (ngSubmit)="onUserSubmit(userForm.value,userForm)" #userForm="ngForm" autocomplete="off">
        <div class="modal-body">
          <div class="alert-danger messagebox warning-msg-box" role="alert" *ngIf="warningmsg">{{messagecont}}</div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="nametext" class="control-label">{{'First Name' | translate}}<span class="required-asterisk">*</span></label>
              <input type="text" #firstname="ngModel" [class.is-invalid]="firstname.invalid && firstname.touched"
                class="form-control form-control-sm" [(ngModel)]='userData.first_name' name="first_name" minlength="2" placeholder=""
                required>
              <div *ngIf="firstname.errors && (firstname.valid || firstname.touched)">
                <small class="text-danger" *ngIf="firstname.errors.required">{{'Firstname is required' | translate}}</small>
                <small class="text-danger" *ngIf="firstname.errors.minlength">{{'Minimum 2 characters required' | translate}}</small>
              </div> 
            </div>
            <div class="form-group col-md-6">
              <label for="nametext" class="control-label">{{'Last Name' | translate}}<span class="required-asterisk">*</span></label>
              <input type="text" #lastname="ngModel" [class.is-invalid]="lastname.invalid && lastname.touched"
                class="form-control form-control-sm" [(ngModel)]='userData.last_name' name="last_name" minlength="2"
                placeholder="{{'Last / Initial' | translate}}" required>
                <div *ngIf="lastname.errors && (lastname.valid || lastname.touched)">
                  <small class="text-danger" *ngIf="lastname.errors.required">{{'Lastname is required' | translate}}</small>
                  <small class="text-danger" *ngIf="lastname.errors.minlength">{{'Minimum 2 characters required' | translate}}</small>
                </div> 
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="nametext" class="control-label">{{'Phone Number' | translate}}<span class="required-asterisk">*</span></label>
              <input type="number" #phonenumber="ngModel"
                [class.is-invalid]="phonenumber.invalid && phonenumber.touched" class="form-control form-control-sm"
                [(ngModel)]='userData.phone' name="phone" pattern="^\d{10}$" placeholder="" required>
              <div *ngIf="phonenumber.errors && (phonenumber.valid || phonenumber.touched)">
                <small class="text-danger" *ngIf="phonenumber.errors.required">{{'Phone number is required' | translate}}</small>
                <small class="text-danger" *ngIf="phonenumber.errors.pattern">{{'Phone number must be 10 digits' | translate}}</small>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label for="nametext" class="control-label">{{'Email Address' | translate}}<span class="required-asterisk">*</span></label>
              <input type="email" #emailaddress="ngModel" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                [class.is-invalid]="emailaddress.invalid && emailaddress.touched" class="form-control form-control-sm"
                [(ngModel)]='userData.email' name="email" placeholder="" required [readonly]="!isUserCreate">
              <div *ngIf="emailaddress.errors && (emailaddress.valid || emailaddress.touched)">
                <small class="text-danger" *ngIf="emailaddress.errors.required">{{'Email is required' | translate}}</small>
                <small class="text-danger" *ngIf="emailaddress.errors.pattern">{{'Email must be a valid email
                  address' | translate}}</small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="organization" class="control-label">{{'Organization' | translate}}</label>
              <select class="form-control custom-select form-control-sm" #maptoroles="ngModel"
                [class.is-invalid]="maptoroles.invalid && maptoroles.touched" name="org_id"
                [(ngModel)]="userData.org_id" [disabled]="userData.default" required>
                <option value='' *ngIf="organizationList && organizationList.length > 1">{{'Please choose an organization' | translate}}</option>
                <option *ngFor="let organization of organizationList" [value]="organization.id">{{organization.org_name}}</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label for="maptoRole" class="control-label">{{'Assignment of Role' | translate}}<span
                  class="required-asterisk">*</span></label>
              <select class="form-control custom-select form-control-sm" #maptoroles="ngModel"
                [class.is-invalid]="maptoroles.invalid && maptoroles.touched" name="role_id"
                [(ngModel)]="userData.role_id" [disabled]="userData.default" required>
                <option value=''>{{'Please choose a role' | translate}}</option>
                <option *ngFor="let role of rolesList" [value]="role.id">{{role.role}}</option>
              </select>
              <small class="text-danger" [class.d-none]="maptoroles.valid || maptoroles.untouched">{{'Please choose a
                role' | translate}}</small>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="username" class="control-label">{{'Username' | translate}}<span class="required-asterisk">*</span></label>
              <input type="text" #loginname="ngModel" [class.is-invalid]="loginname.invalid && loginname.touched"
                class="form-control form-control-sm" [(ngModel)]='userData.username' name="username" placeholder=""
                required>
              <small class="text-danger" [class.d-none]="loginname.valid || loginname.untouched">{{'Username is
                required' | translate}}</small>
            </div>
            <div class="form-group col-md-6">
              <label for="password" class="control-label">{{'Password' | translate}}<span class="required-asterisk">*</span></label>
              <input type="password" class="form-control form-control-sm" [class.is-invalid]="password.invalid && password.touched"
                #password="ngModel" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#^`~)(,:;+&_\-\.\>\<])[A-Za-z\d@$!%*?#^`~)(,:;+&_\-\.\<\>]{10,}$"
                [(ngModel)]='userData.loginpassword' name="password" placeholder="" autocomplete="new-password" [required]="enablePass" [disabled]="!enablePass">
                <small *ngIf="!isUserCreate"><input class="mt-2 mr-1" type="checkbox" #ispassupdate="ngModel" [(ngModel)]='enablePass' name="is_pass_update" (change)="enablePassword($event)">{{'Check here - if you want to update password' | translate}}</small>
              <div *ngIf="password.errors && (password.valid || password.touched)">
                <small class="text-danger" *ngIf="password.errors.required">{{'New Password required' | translate}}</small>
                <small class="text-danger" *ngIf="password.errors.pattern">{{'Password
                  must be at least 10 characters with one uppercase, lowercase, numbers & special characters' | translate}}</small>
              </div>
            </div>
          </div>   
          <div class="form-group">
            <label for="status" class="control-label d-block">{{'Status' | translate}}</label>
            <label class="switch">
              <input type="checkbox" checked="" name="status" [(ngModel)]="userData.status" [disabled]="userData.default">
              <div class="slider round btn-primary">
                <span class="on">{{'Yes' | translate}}</span>
                <span class="off">{{'No' | translate}}</span>
              </div>
            </label>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="userForm.reset()">{{'Cancel' | translate}}</button>
            <button [disabled]="userForm.form.invalid" *ngIf="isUserCreate" type="submit" id="closeUserModal"
              class="btn btn-primary" value="submit">{{'Add User' | translate}}</button>
            <button [disabled]="userForm.form.invalid" *ngIf="!isUserCreate" type="submit" id="closeUserModal"
              class="btn btn-primary" value="submit">{{'Update User' | translate}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="modal fade" id="addRole" tabindex="-1" role="dialog" aria-labelledby="newRoleModal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <app-spinner *ngIf="isModalLoading" class="spinner-position"></app-spinner>
    <div class="modal-content" *ngIf="!isModalLoading">
      <div class="modal-header">
        <h6 class="modal-title" id="newRoleModal" *ngIf="isRoleCreate">{{'Add Role' | translate}}</h6>
        <h6 class="modal-title" id="newRoleModal" *ngIf="!isRoleCreate">{{'Edit Role' | translate}}</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="roleForm.reset()" #closeRole> <span
            aria-hidden="true">×</span>
        </button>
      </div>
      <form (ngSubmit)="onRoleSubmit(roleForm.value,roleForm)" #roleForm="ngForm">
        <div class="modal-body">
          <div class="alert-danger messagebox warning-msg-box" role="alert" *ngIf="warningmsg">{{messagecont}}</div>
          <div class="form-group">
            <label for="rolename" class="control-label">{{'Role Name' | translate}}<span class="required-asterisk">*</span></label>
            <input type="text" #rolename="ngModel" [class.is-invalid]="rolename.invalid && rolename.touched"
              class="form-control form-control-sm" name="user_role" [(ngModel)]="roleData.role" placeholder=""
              [disabled]="!isRoleCreate" required>
            <small class="text-danger" [class.d-none]="rolename.valid || rolename.untouched">{{'Role name is
              required' | translate}}</small>
          </div>
          <div class="form-group">
            <label for="roledesc" class="control-label">{{'Role Description' | translate}}</label>
            <textarea name="textarea" name="description" class="form-control"
              [(ngModel)]="roleData.description"></textarea>
          </div>
          <!-- <div class="form-group">
            <label for="roleactive" class="control-label d-block">Make this Role Active?</label>
            <label class="switch">
              <input type="checkbox" checked="" name="is_active" [(ngModel)]="roleData.status">
              <div class="slider round btn-primary">
                <span class="on">Yes</span>
                <span class="off">No</span>
              </div>
            </label>
          </div> -->
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="roleForm.reset()">{{'Cancel' | translate}}</button>
            <button [disabled]="roleForm.form.invalid" *ngIf="isRoleCreate" type="submit" id="closeRoleModal"
              class="btn btn-primary">{{'Add Role' | translate}}</button>
            <button [disabled]="roleForm.form.invalid" *ngIf="!isRoleCreate" type="submit" id="closeRoleModal"
              class="btn btn-primary" data-dismiss="">{{'Update Role' | translate}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
